import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular/standalone';

/**
 * Route reuse strategy that extends Ionic's default behaviour with an
 * opt-out mechanism: routes flagged with `data: { reuseRoute: false }` are
 * never detached/cached, so Angular destroys their components on navigate
 * away and creates fresh instances on every visit.
 *
 * Used for transient pages like /login, /magic-login etc. where a cached
 * "in-flight" UI state (e.g. spinning Google button) would otherwise
 * reappear after logout.
 */
@Injectable({ providedIn: 'root' })
export class ElectaRouteReuseStrategy extends IonicRouteStrategy {
  override shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (route.data?.['reuseRoute'] === false) {
      return false;
    }
    return super.shouldDetach(route);
  }

  override shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (route.data?.['reuseRoute'] === false) {
      return false;
    }
    return super.shouldAttach(route);
  }
}
